<div
  class="form-checks"
  [ngStyle]="{ 'margin-top': mt + 'px', 'margin-bottom': mb }"
>
  <p-checkbox
    class="form-checks-input"
    value="true"
    [inputId]="id"
    [disabled]="disabled"
    [checked]="value === true"
    [binary]="true"
    [(ngModel)]="value"
    (onChange)="onCheckboxChange($event)"
  />
  <label class="form-check-label font-size-14" [for]="id">
    {{ label }}
  </label>
</div>
